var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[_c('el-main',{staticClass:"main"},[_c('Main')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }